import React, { useState, useEffect } from 'react'
import DashboardLibraryLoader from '../dashboard-deliveries-loader'
import DashboardLibraryEmptyView from '../dashboard-deliveries-empty-view'
import DashboardLibraryUpperRow from '../dashboard-deliveries-upper-row'
import DashboardLibraryTable from '../dashboard-deliveries-table'
import SearchContentField from '../../../universal/search-content-field/search-content-field.component'
import DeliveriesTabs from '../dashboard-deliveries-selection-tabs'

import DashboardDeliveriesNewModal from '../dashboard-deliveries-new-modal'
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { sendErrorNotification, sendSuccessNotification } from '../../../universal/notifications/notifications'
import { resetAddDelivery, retrieveDeliveriesListings, resetDeliveriesListings } from '../../../../redux/actions/deliveries'

const Index = () => {

	const [searchQuery, setSearchQuery] = useState("");

    const dispatch = useDispatch()

    const library = useSelector(state => state && state.library && state.library)
    const modal = useSelector(state => state.deliveries.showModals)

    const user = useSelector(state => state && state.auth && state.auth.user && state.auth.user.id)
    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const addError = useSelector(state => state.deliveries.addDelivery.error)
    const addStatus = useSelector(state => state.deliveries.addDelivery.status)

    const searchLibrary = e => {
        setSearchQuery(e.target.value)
	}

    useEffect(() => {
        dispatch(resetDeliveriesListings())
        dispatch(resetAddDelivery())
      }, []) 

    useEffect(() => {
        if(addStatus && addStatus !== null){
          sendSuccessNotification("Leveransen ble lagt til.")
          dispatch(resetAddDelivery())
          dispatch(retrieveDeliveriesListings({companyId: selectedCompany}))
        }
        if(addError){
          sendErrorNotification("Kunne ikke legge til leveranse.")
          dispatch(resetAddDelivery())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [addStatus, addError])

    

    return(
        <section className="dashboard-library-section">
            <div className="inner-dashboard-library-container">
                <DashboardLibraryUpperRow/>
                <SearchContentField searchQuery={searchQuery} handleSearch={searchLibrary}/>
                <DeliveriesTabs/>
                <DashboardLibraryTable searchQuery={searchQuery}/>
                {library.contentLoading ? <DashboardLibraryLoader/>:null}
                {!library.contentLoading && library.content.length === 0 ? <DashboardLibraryEmptyView/>:null}
                {modal.newModal ? <DashboardDeliveriesNewModal/>:null}
            </div>
            <ToastContainer/>
        </section>
    )
}

export default Index